import { render, staticRenderFns } from "./contact-us.page.vue?vue&type=template&id=6f83b07f&"
import script from "./contact-us.page.vue?vue&type=script&lang=ts&"
export * from "./contact-us.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports